const Keys = {
  DEFAULT_IDX: 0,
  DEFAULT: "0",
  CONTACT_IDX: 0,
  CONTACT: "0",
  NEW_ITEM: "-1"
};

export default Keys;
